import { render, staticRenderFns } from "./CloFooterListItem.vue?vue&type=template&id=27fa3974&"
import script from "./CloFooterListItem.vue?vue&type=script&lang=js&"
export * from "./CloFooterListItem.vue?vue&type=script&lang=js&"
import style0 from "./CloFooterListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports